/* eslint-disable react/forbid-prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import JourneyMap from '../JourneyMap';
import { appealEvent, appealEventClicked, cancelEventAppeal } from './actions';
import { AppealEventPopup } from './AppealEventPopup';

@connect(state => ({
  journey: state.rides.currentJourney,
  firstJourney: state.rides.journeys[0],
  previewedJourney: state.rides.currentPreviewedJourney,
  currentDeviceStats: state.devices.devicesStats.filter(value => value.deviceId === state.devices.currentDevice.id).pop() || {},
  appealing: state.rides.appealing,
  appealingEvent: state.rides.appealingEvent,
  appealingStatus: state.rides.appealingStatus,
}), dispatch => ({
  showAppealForm(event, journeyId) {
    return dispatch(appealEvent({ event, journeyId }));
  },
  hideAppealForm() {
    return dispatch(cancelEventAppeal());
  },
  startEventAppealing(comment) {
    return dispatch(appealEventClicked({ comment }));
  },
}))
export class Rides extends Component {
  handleEventAppeal = (event) => {
    this.props.showAppealForm({ event, journey: this.props.journey || this.props.previewedJourney });
  };
  render() {
    const { appealing, appealingEvent, appealingStatus, hideAppealForm, currentDeviceStats, firstJourney, journey, previewedJourney, startEventAppealing } = this.props;
    return (
      <div className="main-map">
        <div className="main-map__wrapper" style={{ position: 'fixed', left: 356 }}>
          <JourneyMap
            zoomControl
            journey={previewedJourney || journey || firstJourney}
            isPreviewing={!!previewedJourney || !!journey}
            needEventsRender={!!previewedJourney || !!journey}
            currentDeviceStats={currentDeviceStats}
            draggingDisabled={appealing}
            scrollDisabled={appealing}
            renderChildren={appealing}
            onAppealClick={this.handleEventAppeal}
          >
            <div className="marker-popup">
              <div className="marker-popup__wrapper">
                <AppealEventPopup appealingStatus={appealingStatus} eventContainer={appealingEvent} onAppealCancel={hideAppealForm} onAppealSubmit={startEventAppealing} />
              </div>
            </div>
          </JourneyMap>
        </div>
      </div>
    );
  }
}

Rides.WrappedComponent.propTypes = {
  appealing: PropTypes.bool,
  appealingEvent: PropTypes.object,
  appealingStatus: PropTypes.string.isRequired,
  currentDeviceStats: PropTypes.object,
  firstJourney: PropTypes.object,
  journey: PropTypes.object,
  previewedJourney: PropTypes.object,

  showAppealForm: PropTypes.func.isRequired,
  hideAppealForm: PropTypes.func.isRequired,
  startEventAppealing: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Rides/index.js